import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { t } from 'src/lib/language';
import { openDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';

interface OwnProps {
  subscriptionId: number,
}

type Props = OwnProps & ButtonProps;

const DeleteSubscriptionButton = (props: Props) => {
  const { disabled, subscriptionId } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language);

  const handleOpen = () => {
    dispatch(openDialog({ dialog: DIALOGS.deleteSubscription, payload: { subscriptionId } }));
  };

  return (
    <Tooltip
      title={t(lang, 'menus.delete_subscription')}
      placement="top-start">
      <span>
        <ActionButton
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.action}
          onClick={handleOpen}
          disabled={disabled}>
          <DeleteIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default DeleteSubscriptionButton;
